"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInput = void 0;
const __1 = require("..");
const icons_1 = require("../../icons");
const react_1 = __importStar(require("react"));
const fileUtils_1 = require("../utils/fileUtils");
const FileInput = ({ accept, labelPrimary = 'Upload your resume', dropLabel = 'Drop file here', fullWidth, onChange, id, }) => {
    /**
     * @todo add more styling/props for drag over and mouse over, if needed
     */
    const [labelText, setLabelText] = (0, react_1.useState)(labelPrimary);
    const [activeFilename, setActiveFilename] = (0, react_1.useState)(null);
    // const [isDragOver, setIsDragOver] = useState<boolean>(false);
    // const [isMouseOver, setIsMouseOver] = useState<boolean>(false);
    const stopDefaults = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    const inputRef = (0, react_1.useRef)(null);
    const handleChange = async (event) => {
        const file = (event.currentTarget.files && event.currentTarget.files[0]) ||
            (event.dataTransfer?.files && event.dataTransfer?.files[0]) ||
            (event.target?.files && event.target?.files?.[0]);
        if (file) {
            try {
                const { filename, extension, encodedFile } = await (0, fileUtils_1.getFileData)(file);
                onChange({ encodedFile, filename, extension });
                setActiveFilename(`${filename}.${extension}`);
            }
            catch (error) {
                throw new Error(error);
            }
        }
    };
    const handleClear = () => {
        onChange({ encodedFile: null, filename: null, extension: null });
        setActiveFilename(null);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };
    const dragEvents = {
        onMouseEnter: () => {
            // setIsMouseOver(true);
        },
        onMouseLeave: () => {
            // setIsMouseOver(false);
        },
        onDragEnter: (e) => {
            stopDefaults(e);
            // setIsDragOver(true);
            setLabelText(dropLabel);
        },
        onDragLeave: (e) => {
            stopDefaults(e);
            // setIsDragOver(false);
            setLabelText(labelPrimary);
        },
        onDragOver: stopDefaults,
        onDrop: (e) => {
            stopDefaults(e);
            setLabelText(labelPrimary);
            // setIsDragOver(false);
            // @ts-ignore
            handleChange(e);
        },
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { "data-testid": "file-input", onChange: handleChange, accept: accept.join(', '), style: { display: 'none' }, id: id, type: "file", ref: inputRef }),
        react_1.default.createElement("label", { htmlFor: id, ...dragEvents, style: {
                cursor: 'pointer',
                textAlign: 'center',
                display: 'flex',
            } },
            react_1.default.createElement(__1.Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    pointerEvents: 'none',
                    border: '1px dashed',
                    borderColor: 'grey.400',
                    borderRadius: 2,
                    width: fullWidth ? '100%' : undefined,
                    height: '100%',
                } },
                react_1.default.createElement(__1.Box, { width: "100%", height: "100%", display: "flex", alignItems: "center", textAlign: "left", p: 1 },
                    react_1.default.createElement(icons_1.CloudUpload, null),
                    react_1.default.createElement(__1.Box, { ml: 2 },
                        react_1.default.createElement(__1.Typography, { variant: "body2" }, labelText),
                        react_1.default.createElement(__1.Typography, { variant: "caption", color: "textSecondary" }, `Supports ${accept.join(', ')}`))))),
        activeFilename && (react_1.default.createElement(__1.Card, { sx: { my: 2 } },
            react_1.default.createElement(__1.CardContent, null,
                react_1.default.createElement(__1.Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
                    react_1.default.createElement(__1.Typography, null, activeFilename),
                    react_1.default.createElement(__1.IconButton, { onClick: handleClear, "data-testid": "file-name-close" },
                        react_1.default.createElement(icons_1.Close, { color: "danger" }))))))));
};
exports.FileInput = FileInput;
exports.default = exports.FileInput;
